// Subscription plans — display source for landing + pricing page.
// Backend (server.py PLANS) is the source of truth for the actual credit grants.
import { Sparkles, Rocket, Crown, Gift } from "lucide-react";

export const YEARLY_DISCOUNT = 0.15; // annual plans get 15% off (~2 months free)
export const yearlyPrice = (monthly) => Math.round(monthly * 12 * (1 - YEARLY_DISCOUNT) * 100) / 100;
export const money = (n) => (Number.isInteger(Number(n)) ? String(n) : Number(n).toFixed(2));

export const PLANS = [
  {
    id: "free",
    name: "Free Trial",
    price: 0,
    oldPrice: null,
    period: "trial",
    icon: Gift,
    tagline: "Make a couple of full short videos, on us",
    cta: "Start free with email",
    features: [
      "Sign up with just your email",
      "≈ 2 full short videos included",
      "AI scripts (Claude)",
      "Studio voiceover (ElevenLabs)",
      "AI scene visuals",
      "Full HD 1080p renders",
      "Preview & download",
    ],
  },
  {
    id: "starter",
    name: "Starter",
    price: 19,
    oldPrice: 39,
    period: "month",
    icon: Sparkles,
    tagline: "For consistent solo creators",
    cta: "Upgrade to Starter",
    features: [
      "1,000 credits / month (~20 short videos)",
      "Long-form & short-form videos in Full HD 1080p",
      "All AI voices & visuals",
      "Schedule to YouTube, TikTok & Instagram",
      "Up to 3 active series",
      "Email notifications",
    ],
  },
  {
    id: "creator",
    name: "Creator",
    price: 39,
    oldPrice: 59,
    period: "month",
    icon: Rocket,
    popular: true,
    tagline: "For growing channels",
    cta: "Upgrade to Creator",
    features: [
      "3,500 credits / month (~70 short videos)",
      "Everything in Starter",
      "Up to 6 active series",
      "Priority generation queue",
      "Premium ElevenLabs voices",
      "Bulk 'generate all visuals'",
    ],
  },
  {
    id: "studio",
    name: "Studio",
    price: 79,
    oldPrice: 99,
    period: "month",
    icon: Crown,
    tagline: "For agencies & full-time creators",
    cta: "Upgrade to Studio",
    features: [
      "7,500 credits / month (~150 short videos)",
      "Everything in Creator",
      "12 series schedules",
      "Multiple brand profiles",
      "Highest priority generation",
      "Priority support",
      "Early access to new features",
    ],
  },
];
